export const serverIP = 'www.engineerix.com.mx'; //'45.33.122.43'// 'www.engineerix.com.mx';
//export const serverIP = '72.14.185.242';
export const serverIPn = '45.33.122.43'// '72.14.185.242';
export const port = '';
export const requestType = 'https';
export const requestWSType = 'wss';

/*
let dev = false;
export const serverIP =(dev? 'localhost':window.location.hostname)
export const serverVideo =(dev? 'localhost':window.location.hostname)
export const serverIPn = (dev? 'localhost':window.location.hostname)
export const port =  (dev? '3015':window.location.port)
export const portVideo =  (dev? '3015':window.location.port)
export const requestType = (dev? 'http':window.location.protocol.replace(':', ''));
export const requestWSType = (dev? 'ws':(window.location.protocol.replace(':', '') === 'http'? 'ws':'wss'));
*/